export default __webpack_public_path__ + "static/cell-dae3ff81466c9624d2bcb471010ae8e8.svg";